import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { TopBarConfig } from '@modules/shared/top-bar/top-bar-config';
import { MenuActionId } from '@shared/models/menu-actions/menu-action-id.enum';
import { Observable } from 'rxjs';

type SadmGridTopBarBuilderOptions = {
  saveDisabled$: Observable<boolean>;
  onClose: () => void;
  onSave: () => void;
};

@Injectable({ providedIn: 'root' })
export class SadmGridTopBarBuilderService {
  private readonly translocoService = inject(TranslocoService);

  build({ saveDisabled$, onClose, onSave }: SadmGridTopBarBuilderOptions): TopBarConfig {
    return {
      title: this.translocoService.translate('Lésion'),
      leftActions: [
        {
          id: MenuActionId.BACK,
          hint: this.translocoService.translate('Quitter'),
          icon: '@tui.x',
          execute: onClose,
        },
      ],
      rightActions: [
        {
          id: MenuActionId.FORM_GRID_SAVE,
          label: this.translocoService.translate('Enregistrer'),
          hint: this.translocoService.translate('Enregistrer les modifications'),
          execute: onSave,
        },
      ],
      rightButtons: [
        {
          title: this.translocoService.translate('Enregistrer'),
          appearance: 'primary',
          actionIds: [MenuActionId.FORM_GRID_SAVE],
          disabled$: saveDisabled$,
        },
      ],
    };
  }
}
